export const unitPermissions = [
  {
    label: "View",
    value: "VIEW_UNIT_INFORMATION",
  },
  {
    label: "Update summary",
    value: "UPDATE_UNIT_SUMMARY",
  },
  {
    label: "Update entity",
    value: "UPDATE_UNIT_ENTITY",
  },
];

export const facultyProfilePermissions = [
  {
    label: "View",
    value: "VIEW_FACULTY_MEMBERS",
  },
  {
    label: "Update summary",
    value: "UPDATE_FACULTY_MEMBER_SUMMARY",
  },
  {
    label: "Update entity",
    value: "UPDATE_FACULTY_MEMBER_ENTITY",
  },
];
